import { userHasAccess } from "services/LoginFunctions"
import Button from "react-bootstrap/Button"

import { ROLE } from "constants/userRoles"

import stdStyle from "json/StdStyles.json"

const mostrarBotao = process.env.REACT_APP_BOTOES_AUTO_PREENCHIMENTO === "true" || userHasAccess(ROLE.TESTER)

export function BotaoAutoPreenchimento ()
{
    return (
        mostrarBotao ?
        <>
            <hr className="text-primary opacity-100" />
            <div className="d-flex justify-content-around mb-2" >
            <Button className={stdStyle.button} variant="success" onClick={AutoPreenchimento}>Auto preenchimento</Button>
            </div>
        </> :
        <></>
    )
}

function AutoPreenchimento()
{
    const listInputs = document.getElementsByTagName("input")
    for (let i = 0 ; i <= listInputs.length - 1 ; i += 1)
    {
        if (listInputs[i].type === "date") { listInputs[i].value = "2023-06-12" ; continue }
        if (listInputs[i].type === "checkbox") { listInputs[i].value = (i % 2 === 0) ; continue }
        if (listInputs[i].type === "file") { continue }
        if (listInputs[i].value !== "") { continue }

        if (listInputs[i].type === "number" && listInputs[i].placeholder) { listInputs[i].value = Number(listInputs[i].placeholder.replace(" m²", "").replace(" m", "")) + 1 ; continue }
        if (listInputs[i].placeholder) { listInputs[i].value = listInputs[i].placeholder ; continue }

        listInputs[i].value = i
    }

    const listTextarea = document.getElementsByTagName("textarea")
    for (let i = 0 ; i <= listTextarea.length - 1 ; i += 1)
    {
        if (listTextarea[i].value !== "") { continue }

        listTextarea[i].value = "texto"
    }

    const listSelects = document.getElementsByTagName("select")
    for (let i = 0 ; i <= listSelects.length - 1 ; i += 1)
    {
        listSelects[i].value = listSelects[i].options[listSelects[i].options.length - 1].value
    }

    document.querySelector("button[type='submit']").click()
}

function fillAdminData()
{
    const listInputs = document.getElementsByTagName("input")
    if (listInputs !== null & listInputs !== undefined)
    {
        listInputs[0].value = "000001"
        listInputs[1].value = "123456"
    }
}

// async function RecalcularTaxasGuias()
// {
//     const processosComDocs = [...processosPRD].filter(proc => proc.Documentos && 1 <= proc.Documentos.length)
//     let testeResultado = [...processosComDocs]

//     let docs = []
//     testeResultado.forEach(proc => docs.push.apply(docs, proc.Documentos))

//     const guias = docs.filter(doc => doc.tipoDoc === "GuiaPag")
//     const guiasExcetoProtocolo = guias.filter(guia => !guia.detalhesGuia.taxInputs.fatoGeradorProtocolo)
     
//     const mapDocDoraServ =
//     {
//         "Habitese": "CertHabitese",
//         "TermoRemDesm": "TermoDesmRem",
//         "TermoDesmLote": "TermoDesm",
//         "TermoDesmGleba": "TermoDesm"
//     }
//     // console.log(processosPRD)
//     // console.log(testeResultado)
    
//     function recalcularTaxas()
//     {
//         guiasExcetoProtocolo.forEach(async guia => 
//         {
//             let servicoDora = ""
//             if (guia.detalhesGuia.tipoDocDestino)
//             {
//                 servicoDora = Object.keys(mapDocDoraServ).includes(guia.detalhesGuia.tipoDocDestino) ? mapDocDoraServ[guia.detalhesGuia.tipoDocDestino] : guia.detalhesGuia.tipoDocDestino
//             }
//             else
//             {                
//                 if (guia.fatoGerador.includes("Certidão de Demolição sem Autorização"))
//                 {
//                     servicoDora = "CertDemolSemAut"
//                 }
//             }
//             // const servicoDora = determinaServicoEscolhido(guia.detalhesGuia.tipoDocDestino, SERVICOSTAXAS.SERVICOSTAXAS)
//             // console.log(guia.detalhesGuia.tipoDocDestino + " : " + servicoDora)
//             let inputsTaxas = {...guia.detalhesGuia.taxInputs}
//             // console.log("tipo imovel: " + inputsTaxas.tipoImovel)
            
//             if (inputsTaxas.tipoImovel)
//             {
//                 if (inputsTaxas.tipoImovel === "Não residencial / mistoo" || inputsTaxas.tipoImovel === "Galpão / depósito / indústria")
//                 {
//                     inputsTaxas.tipoImovel = "NaoResidencial"
//                 }
//                 else
//                 {
//                     inputsTaxas.tipoImovel = MapTipoImovelToEnumText(inputsTaxas.tipoImovel)
//                 }
//             }
            
//             if (inputsTaxas.usoAreaAverbada)
//             {
//                 inputsTaxas.usoAreaAverbada = MapTipoImovelToEnumText(inputsTaxas.usoAreaAverbada)
//             }
//             if (servicoDora === "CertRegul" && !inputsTaxas.executadaComLicenca)
//             {
//                 inputsTaxas["executadaComLicenca"] = false
//             }

//             const calcTaxaBody = MapInputsToTaxBody(servicoDora, inputsTaxas)
//             let formattedCalcTaxaBody = {...calcTaxaBody}
//                 Object.entries(formattedCalcTaxaBody).forEach(entry => {
//                     if (entry[1] === "on")
//                     {
//                         formattedCalcTaxaBody[entry[0]] = true
//                     }
//                 })
//             // console.log("guia " + guia._id.$oid)
//             // console.log(guia.detalhesGuia.tipoDocDestino + " : " + servicoDora)
//             // console.log(inputsTaxas.tipoImovel)
//             // console.log(formattedCalcTaxaBody)
//             // console.log(guia.proprietario)
//             // console.log(guia.taxas)
            
//             const taxResults = await CalcTax(servicoDora, formattedCalcTaxaBody, "v2", {sucess : undefined, error: undefined})
//             guia.taxas["desconto"] = Number(taxResults.desconto)
//             guia.taxas["outorga"] = Number(taxResults.outorga)
//             // console.log(taxResults.desconto + " " + taxResults.outorga)
//             // console.log(guia.taxas)
//         })

//     console.log(guiasExcetoProtocolo)
//     console.log(processosComDocs);
//     }
    
//     function pegarGuiasProcesso(proc, incluirProtocolo)
//     {
//         let docs = []
//         // testeResultado.forEach(proc => docs.push.apply(docs, proc.Documentos))
//         docs.push.apply(docs, proc.Documentos)
//         if (incluirProtocolo)
//         {
//             return docs.filter(doc => doc.tipoDoc === "GuiaPag")
//         }

//         return docs.filter(doc => doc.tipoDoc === "GuiaPag").filter(guia => !guia.detalhesGuia.taxInputs.fatoGeradorProtocolo)
//     }
//     function pegarGuia(idGuia) { return guiasExcetoProtocolo.filter(g => g._id.$oid === idGuia)[0]}
    
//     function conferirTaxas()
//     {    
//         console.log(processosPRD);
        
//         [...processosPRD].forEach(proc =>
//         {
//             const guias = pegarGuiasProcesso(proc, false)
//             guias.forEach(guia => {

//                 const taxaTotalOriginal = guia.taxas.taxaTotal
//                 const taxaTotalRecalculada = guiasExcetoProtocolo.filter(g => g._id.$oid === guia._id.$oid)[0].taxas.taxaTotal

//                 const descontoOriginal = guia.taxas.desconto
//                 const descontoRecalculado = guiasExcetoProtocolo.filter(g => g._id.$oid === guia._id.$oid)[0].taxas.desconto

//                 const outorgaOriginal = guia.taxas.outorga
//                 const outorgaRecalculada = guiasExcetoProtocolo.filter(g => g._id.$oid === guia._id.$oid)[0].taxas.outorga

//                 if (taxaTotalOriginal !== taxaTotalRecalculada)
//                 {
//                     console.log(guia._id.$oid)
//                     console.log("Taxa total era " + taxaTotalOriginal + " e passou a ser " + taxaTotalRecalculada)
//                 }
//                 console.log("Desconto era " + descontoOriginal + " e passou a ser " + descontoRecalculado)
//                 console.log("Outorga era " + outorgaOriginal + " e passou a ser " + outorgaRecalculada)
//             })
//         })
//     }

//     function addModifiedAt()
//     {

//     }


//     // recalcularTaxas()
//     // conferirTaxas()
//     // addModifiedAt()
//         // console.log(processosPRD);
// }

// export const BotaoRecalcularTaxasGuias = () =>
// {
//     return <Button onClick={RecalcularTaxasGuias}>Recalcular taxas de todas as guias</Button>
// }

export function BotaoLogarAdmin({ target })
{
    return mostrarBotao ? <Button className="mt-3" type="submit" ref={target} onClick={fillAdminData} >Entrar admin</Button> : <></>
}